<template>
  <div>
    <div class="image-center-empty-mail">
      <img
        v-if="folder"
        :src="getTypeofEmpty()"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    folder: {
      type: String,
      default: "Inbox",
    },
  },

  data() {
    return {
        list_of_empty: [
      { folder: "all", src: require("@/assets/img/email/empty/no-results.svg") },
      { folder: "Inbox", src: require("@/assets/img/email/empty/empty-inbox.svg") },
      { folder: "drafts", src: require("@/assets/img/email/empty/empty-drafts.svg") },
      { folder: "SentItems", src: require("@/assets/img/email/empty/empty-outbox.svg") },
    ],
    };
  },

  methods: {
    getTypeofEmpty() {
      let found_folder = this.list_of_empty.find(
        (p) => p.folder == this.folder
      );


      return found_folder.src;
    },
  },
};
</script>

<style></style>
